import React from 'react';

import StepperComponent, { Stepper } from 'retired/Stepper';

import { TitleDescriptionImage } from './steps/01-TitleDescriptionImage';
import { LeaderListController } from './steps/02-Leaders';
import { NonprofitsController } from './steps/03-Nonprofits';

interface CommunityFormProps {
  entityType?: 'team' | 'community';
}

export const CommunityForm = ({ entityType = 'community' }: CommunityFormProps): JSX.Element => {
  const isTeam = entityType === 'team';

  const steps: { id: string; label: string; content: JSX.Element }[] = [
    {
      id: 'title-description-image',
      label: 'Header and Banner Settings',
      content: <TitleDescriptionImage entityType={entityType} />,
    },
    {
      id: 'leaders',
      label: isTeam ? 'Team Management' : 'Community Management',
      content: <LeaderListController entityType={entityType} />,
    },
    ...(isTeam
      ? []
      : [
          {
            id: 'nonprofits',
            label: 'Select partner organizations',
            content: <NonprofitsController />,
          },
        ]),
  ];

  return (
    <Stepper orientation="vertical">
      {steps.map((item, index: number) => (
        <StepperComponent key={item.id} labelText={item.label} componentIndex={index}>
          {item.content}
        </StepperComponent>
      ))}
    </Stepper>
  );
};
